module.exports = __webpack_public_path__ + "img/sld_scb_6_t1_red.036e8208.svg";